import { V as VaAccordion } from "../../components/va-accordion/index-ee005934.mjs";
import { V as VaAffix } from "../../components/va-affix/index-f3e0c8a3.mjs";
import { V as VaAlert } from "../../components/va-alert/index-df75ec44.mjs";
import { V as VaAppBar } from "../../components/va-app-bar/index-b9681290.mjs";
import { V as VaAspectRatio } from "../../components/va-aspect-ratio/index-86d3245b.mjs";
import { V as VaAvatar } from "../../components/va-avatar/index-9299ef14.mjs";
import { V as VaAvatarGroup } from "../../components/va-avatar-group/index-e4000fdd.mjs";
import { V as VaBacktop } from "../../components/va-backtop/index-c6378bde.mjs";
import { V as VaBadge } from "../../components/va-badge/index-5a6b91e1.mjs";
import { a as VaBreadcrumbs, V as VaBreadcrumbsItem } from "../../components/va-breadcrumbs/index-7b762035.mjs";
import { V as VaButton } from "../../components/va-button/index-e7ff1275.mjs";
import { V as VaButtonDropdown } from "../../components/va-button-dropdown/index-456e4134.mjs";
import { V as VaButtonGroup } from "../../components/va-button-group/index-cb631da4.mjs";
import { V as VaButtonToggle } from "../../components/va-button-toggle/index-04583a6a.mjs";
import { d as VaCard, b as VaCardActions, c as VaCardBlock, V as VaCardContent, a as VaCardTitle } from "../../components/va-card/index-97add31d.mjs";
import { V as VaCarousel } from "../../components/va-carousel/index-9e0f0ae9.mjs";
import { V as VaCheckbox } from "../../components/va-checkbox/index-8e6c606e.mjs";
import { V as VaChip } from "../../components/va-chip/index-9493e067.mjs";
import { V as VaCollapse } from "../../components/va-collapse/index-e5837abc.mjs";
import { V as VaColorIndicator } from "../../components/va-color-indicator/index-cd7e8ec1.mjs";
import { V as VaColorInput } from "../../components/va-color-input/index-e1cb4125.mjs";
import { V as VaColorPalette } from "../../components/va-color-palette/index-79abd56c.mjs";
import { V as VaConfig } from "../../components/va-config/VaConfig-594daf87.mjs";
import { V as VaContent } from "../../components/va-content/index-34c579c8.mjs";
import { V as VaCounter } from "../../components/va-counter/index-92bb5c98.mjs";
import { V as VaDataTable } from "../../components/va-data-table/index-23844500.mjs";
import { V as VaDateInput } from "../../components/va-date-input/index-b5b79a92.mjs";
import { V as VaDatePicker } from "../../components/va-date-picker/index-be4cd5bc.mjs";
import { V as VaDivider } from "../../components/va-divider/index-42b307ad.mjs";
import { V as VaDropdown } from "../../components/va-dropdown/index-8fef29c8.mjs";
import { V as VaDropdownContent } from "../../components/va-dropdown/components/VaDropdownContent/index-b7e39405.mjs";
import { V as VaFallback } from "../../components/va-fallback/index-a8167fb1.mjs";
import { V as VaFileUpload } from "../../components/va-file-upload/index-ce026e92.mjs";
import { V as VaForm } from "../../components/va-form/index-8f075a44.mjs";
import { V as VaHover } from "../../components/va-hover/index-ac779a9e.mjs";
import { V as VaIcon } from "../../components/va-icon/index-b0729838.mjs";
import { V as VaImage } from "../../components/va-image/index-4490b965.mjs";
import { V as VaInfiniteScroll } from "../../components/va-infinite-scroll/index-a81edb03.mjs";
import { V as VaInnerLoading } from "../../components/va-inner-loading/index-ba720a8f.mjs";
import { V as VaInput } from "../../components/va-input/index-463a53b5.mjs";
import { b as VaList, V as VaListItem, d as VaListItemLabel, a as VaListItemSection, c as VaListLabel, e as VaListSeparator } from "../../components/va-list/index-82910b3a.mjs";
import { V as VaMessageList } from "../../components/va-input/components/VaMessageList/index-b2fc2774.mjs";
import { V as VaModal } from "../../components/va-modal/VaModal-d5f2721d.mjs";
import { V as VaNavbar, a as VaNavbarItem } from "../../components/va-navbar/index-2cc04440.mjs";
import { V as VaOptionList } from "../../components/va-option-list/index-ed1d3f50.mjs";
import { V as VaPagination } from "../../components/va-pagination/index-18fbfd0f.mjs";
import { V as VaParallax } from "../../components/va-parallax/index-f30607c3.mjs";
import { V as VaPopover } from "../../components/va-popover/index-5f47de0b.mjs";
import { V as VaProgressBar } from "../../components/va-progress-bar/index-50370cf3.mjs";
import { V as VaProgressCircle } from "../../components/va-progress-circle/index-0664da55.mjs";
import { V as VaRadio } from "../../components/va-radio/index-2e30708d.mjs";
import { V as VaRating } from "../../components/va-rating/index-597d50c7.mjs";
import { V as VaSelect } from "../../components/va-select/index-cc407feb.mjs";
import { V as VaSeparator } from "../../components/va-separator/VaSeparator-441efce1.mjs";
import { V as VaSkeleton, a as VaSkeletonGroup } from "../../components/va-skeleton/index-7d8cf794.mjs";
import { V as VaSidebar } from "../../components/va-sidebar/index-b8b57102.mjs";
import { V as VaSidebarItem, a as VaSidebarItemContent, b as VaSidebarItemTitle } from "../../components/va-sidebar/VaSidebarItem/index-e5686de2.mjs";
import { V as VaSlider } from "../../components/va-slider/index-f242a1f6.mjs";
import { V as VaSpacer } from "../../components/va-spacer/VaSpacer-c6cc3351.mjs";
import { V as VaSplit } from "../../components/va-split/index-64f4121c.mjs";
import { V as VaSwitch } from "../../components/va-switch/index-b9ab315d.mjs";
import { V as VaTabs } from "../../components/va-tabs/index-ab3ae381.mjs";
import { V as VaTab } from "../../components/va-tabs/components/VaTab/index-4128eb01.mjs";
import { V as VaStepper } from "../../components/va-stepper/index-5d28338f.mjs";
import { V as VaTimeInput } from "../../components/va-time-input/index-bbfffcc6.mjs";
import { V as VaTimeline } from "../../components/va-timeline/index-591da745.mjs";
import { V as VaTimelineItem } from "../../components/va-timeline/VaTimelineItem/index-64557ce2.mjs";
import { V as VaTimePicker } from "../../components/va-time-picker/index-fad0ec91.mjs";
import { V as VaToast } from "../../components/va-toast/index-72dd896d.mjs";
import { V as VaTreeView } from "../../components/va-tree-view/index-41b919ad.mjs";
import { V as VaScrollContainer } from "../../components/va-scroll-container/index-c0551dc2.mjs";
import { V as VaViewer } from "../../components/va-viewer/index-222ecabb.mjs";
import { V as VaValue } from "../../components/va-value/index-ea28be0a.mjs";
import { V as VaVirtualScroller } from "../../components/va-virtual-scroller/index-268e7180.mjs";
const vuesticComponents = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  VaAccordion,
  VaAffix,
  VaAlert,
  VaAppBar,
  VaAspectRatio,
  VaAvatar,
  VaAvatarGroup,
  VaBacktop,
  VaBadge,
  VaBreadcrumbs,
  VaBreadcrumbsItem,
  VaButton,
  VaButtonDropdown,
  VaButtonGroup,
  VaButtonToggle,
  VaCard,
  VaCardActions,
  VaCardBlock,
  VaCardContent,
  VaCardTitle,
  VaCarousel,
  VaCheckbox,
  VaChip,
  VaCollapse,
  VaColorIndicator,
  VaColorInput,
  VaColorPalette,
  VaConfig,
  VaContent,
  VaCounter,
  VaDataTable,
  VaDateInput,
  VaDatePicker,
  VaDivider,
  VaDropdown,
  VaDropdownContent,
  VaFallback,
  VaFileUpload,
  VaForm,
  VaHover,
  VaIcon,
  VaImage,
  VaInfiniteScroll,
  VaInnerLoading,
  VaInput,
  VaList,
  VaListItem,
  VaListItemLabel,
  VaListItemSection,
  VaListLabel,
  VaListSeparator,
  VaMessageList,
  VaModal,
  VaNavbar,
  VaNavbarItem,
  VaOptionList,
  VaPagination,
  VaParallax,
  VaPopover,
  VaProgressBar,
  VaProgressCircle,
  VaRadio,
  VaRating,
  VaScrollContainer,
  VaSelect,
  VaSeparator,
  VaSidebar,
  VaSidebarItem,
  VaSidebarItemContent,
  VaSidebarItemTitle,
  VaSkeleton,
  VaSkeletonGroup,
  VaSlider,
  VaSpacer,
  VaSplit,
  VaStepper,
  VaSwitch,
  VaTab,
  VaTabs,
  VaTimeInput,
  VaTimePicker,
  VaTimeline,
  VaTimelineItem,
  VaToast,
  VaTreeView,
  VaValue,
  VaViewer,
  VaVirtualScroller
}, Symbol.toStringTag, { value: "Module" }));
export {
  vuesticComponents as v
};
//# sourceMappingURL=components-cf1f3293.mjs.map
